import { DataModelValidatorType } from '@flowx/designer/modules/core/dictionary/data-model.dictionary'
import { DefaultUIAttributeType } from '@flowx/designer/shared/entities/data-model.entity'

export const VALIDATORS_WITHOUT_PARAMS: DataModelValidatorType[] = [
  DataModelValidatorType.REQUIRED,
  DataModelValidatorType.EMAIL,
]

export const GENERAL_VALIDATOR_TYPES: DataModelValidatorType[] = [
  DataModelValidatorType.REQUIRED,
  DataModelValidatorType.CUSTOM_EXPRESSION,
]

export const NUMERIC_PARAM_VALIDATORS: DataModelValidatorType[] = [
  DataModelValidatorType.MIN_LENGTH,
  DataModelValidatorType.MAX_LENGTH,
  DataModelValidatorType.MIN_ITEMS,
  DataModelValidatorType.MAX_ITEMS,
]

export const DataModelValidatorLabels: Record<DataModelValidatorType, string> = {
  [DataModelValidatorType.REQUIRED]: 'Required field',
  [DataModelValidatorType.MIN_LENGTH]: 'Min Length',
  [DataModelValidatorType.MAX_LENGTH]: 'Max Length',
  [DataModelValidatorType.MIN_VALUE]: 'Min Value',
  [DataModelValidatorType.MAX_VALUE]: 'Max Value',
  [DataModelValidatorType.PATTERN]: 'Pattern',
  [DataModelValidatorType.EMAIL]: 'Email Format',
  [DataModelValidatorType.MIN_ITEMS]: 'Min Items',
  [DataModelValidatorType.MAX_ITEMS]: 'Max Items',
  [DataModelValidatorType.CUSTOM_EXPRESSION]: 'Custom Expression',
}

export const DataModelValidatorIcons: Record<DataModelValidatorType, string> = {
  [DataModelValidatorType.REQUIRED]: 'ph-asterisk',
  [DataModelValidatorType.MIN_LENGTH]: 'ph-ruler',
  [DataModelValidatorType.MAX_LENGTH]: 'ph-ruler',
  [DataModelValidatorType.MIN_VALUE]: 'ph-arrows-vertical',
  [DataModelValidatorType.MAX_VALUE]: 'ph-arrows-vertical',
  [DataModelValidatorType.PATTERN]: 'ph-brackets-angle',
  [DataModelValidatorType.EMAIL]: 'ph-envelope-simple',
  [DataModelValidatorType.MIN_ITEMS]: 'ph-brackets-square',
  [DataModelValidatorType.MAX_ITEMS]: 'ph-brackets-square',
  [DataModelValidatorType.CUSTOM_EXPRESSION]: 'ph-brackets-curly',
}

export const DATA_MODEL_TYPE_VALIDATORS_MAP: Record<string, DataModelValidatorType[]> = {
  [DefaultUIAttributeType.STRING]: [
    DataModelValidatorType.REQUIRED,
    DataModelValidatorType.MIN_LENGTH,
    DataModelValidatorType.MAX_LENGTH,
    DataModelValidatorType.PATTERN,
    DataModelValidatorType.EMAIL,
  ],
  [DefaultUIAttributeType.NUMBER]: [
    DataModelValidatorType.REQUIRED,
    DataModelValidatorType.MIN_VALUE,
    DataModelValidatorType.MAX_VALUE,
  ],
  [DefaultUIAttributeType.BOOLEAN]: [DataModelValidatorType.REQUIRED],
  [DefaultUIAttributeType.DATE]: [
    DataModelValidatorType.REQUIRED,
    DataModelValidatorType.MIN_VALUE,
    DataModelValidatorType.MAX_VALUE,
  ],
  [DefaultUIAttributeType.ENUM]: [DataModelValidatorType.REQUIRED],
  [DefaultUIAttributeType.ARRAY]: [
    DataModelValidatorType.REQUIRED,
    DataModelValidatorType.MIN_ITEMS,
    DataModelValidatorType.MAX_ITEMS,
  ],
  [DefaultUIAttributeType.NEW_OBJECT]: [DataModelValidatorType.REQUIRED],
  [DefaultUIAttributeType.EXISTING_OBJECT]: [DataModelValidatorType.REQUIRED],
  [DefaultUIAttributeType.CURRENCY]: [
    DataModelValidatorType.REQUIRED,
    DataModelValidatorType.MIN_VALUE,
    DataModelValidatorType.MAX_VALUE,
    DataModelValidatorType.MIN_LENGTH,
    DataModelValidatorType.MAX_LENGTH,
    DataModelValidatorType.PATTERN,
  ],
}

export const CURRENCY_VALIDATOR_LABELS: Partial<Record<DataModelValidatorType, string>> = {
  [DataModelValidatorType.MIN_VALUE]: 'Min Amount Value',
  [DataModelValidatorType.MAX_VALUE]: 'Max Amount Value',
  [DataModelValidatorType.MIN_LENGTH]: 'Min Code Length',
  [DataModelValidatorType.MAX_LENGTH]: 'Max Code Length',
  [DataModelValidatorType.PATTERN]: 'Code Pattern (regex)',
}
